const translations = {
    title_choose_example: "Beispiel A[rt]quarelle",
    info_examples:
      "Das von dir hochgeladene Bild wird wie in den hier gezeigten Beispielen illustriert. Die Farbwahl der Effekte erfolgen passend zu deinem Foto.",
    background: "Wähle einen Hintergrund",
    title_font_top: "Wähle eine Schriftart oben",
    text_top: "Text oben",
    placeholder_text_top: " ",
    label_text_color: "Textfarbe",
    title_font_bottom: "Wähle eine Schriftart unten",
    text_bottom: "Text unten",
    placeholder_text_bottom: " ",
    image: "Dein Foto",
    express: "Versandart",
    info_digital:
      "<br>Achtung! Du erhältst kein physisches Produkt sondern eine digitale Druckdatei im DIN A4/A3 Format. <br><small> Die Druckdatei (JPG) senden wir dir innerhalb von 1-3 Werktagen per E-Mail zu. Du kannst die Datei nutzen, um selbst ein Poster zu drucken.",
    express_info:
      'Du erhältst dein Wandbild in 2-4 Werktagen. <a href="/pages/shippingOptions"><b> Mehr Informationen </b></a>',
    info_choose_image:
      "Ein Live-Preview ist leider nicht möglich, da <b>jedes Portrait individuell illustriert </b> wird. Aber keine Sorge - du erhältst vor Anfertigung des Wandbildes <b> eine Vorschau deines Portraits per E-Mail </b> zugesendet.",
    info_taxes: "Preis inkl. MwSt. | <b>Lieferung ohne Rahmen</b>",
    la_title_choose_example: "1. Wähle ein Beispiel",
    la_info_examples:
      "Das von Ihnen hochgeladene Bild wird wie in den hier gezeigten Beispielen dargestellt.",
    la_background: "2. Wähle einen Hintergrund",
    la_effect_color: "3. Wähle eine Effektfarbe.",
    la_info_mask: "Wir passen die Positionierung basierend auf Ihrem Foto an.",
    la_text: "4. Wähle Deine Beschriftung.",
    text_single: "Deine Beschriftung",
    placeholder_text_single: "Z.b. Name deines Lieblings",
    title_choose_example_image: "Beispiel Bilder",
    choose_design: "Farbwahl",
    dark: "Dunkeles Design",
    bright: "Helles Design",
    passepartout: "Passepartout"
  };

  const artworkSetting = {
    fontCategories: ["nc"],
    expressAvailable: true,
  };

  const themeSettings = {
    watercolor: {
      baby: {
        text_top: "Johan",
        text_bottom: "26 Juni 2023",
        default_example: "baby_6",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
      wedding: {
        text_top: "Für immer Wir",
        text_bottom: "17 Juni 2018",
        default_example: "wedding_4",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
          },
      trauergeschenk: {
        text_top: "Für immer im Herzen",
        text_bottom: "Margarete",
        default_example: "trauergeschenk_3",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
      car: {
        text_top: "Volkswagen",
        text_bottom: "139 PS",
        default_example: "car_6",
        font_top: "nc_font_2",
        font_bottom: "nc_font_4",
      },
      traktor: {
        text_top: "John Deere",
        text_bottom: "by Jupp",
        default_example: "traktor_2",
        font_top: "nc_font_4",
        font_bottom: "nc_font_4",
      },
      lkw: {
        text_top: "MAN",
        text_bottom: "von Robin",
        default_example: "lkw_7",
        font_top: "nc_font_2",
        font_bottom: "nc_font_4",
      },
      camper: {
        text_top: "Unser Zuhause",
        text_bottom: "2020 - 2022",
        default_example: "camper_4",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
      bike: {
        text_top: "Dein Motorrad",
        text_bottom: "als Aquarell",
        default_example: "bike_5",
        font_top: "nc_font_1",
        font_bottom: "nc_font_4",
      },
      person: {
        text_top: "Für immer Wir",
        text_bottom: "17 Juni 2018",
        default_example: "person_1",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
      animal: {
        text_top: "Luna",
        text_bottom: "Herz auf vier Pfoten",
        default_example: "animal_1",
        font_top: "nc_font_4",
        font_bottom: "nc_font_1",
      },
         papa: {
        text_top: "DreamTeam",
        text_bottom: "Tabea & Markus",
        default_example: "papa_1",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
         mama: {
        text_top: "Beste Mama der Welt",
        text_bottom: "Beate & Julia",
        default_example: "mama_2",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
         lehrerin: {
        text_top: "Our Happy Place",
        text_bottom: "Familie Müller",
        default_example: "lehrerin_1",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
      dog: {
        text_top: "Emma",
        text_bottom: "best buddy",
        default_example: "dog_1",
        font_top: "nc_font_1",
        font_bottom: "nc_font_4",
      },
      cat: {
        text_top: "Balou",
        text_bottom: "best buddy",
        default_example: "cat_1",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
      horse: {
        text_top: "Akira & Ariane",
        text_bottom: "16 Oktober 2017",
        default_example: "horse_2",
        font_top: "nc_font_4",
        font_bottom: "nc_font_2",
      },
      family: {
        text_top: "Dreamteam",
        text_bottom: "gemeinsam stark",
        default_example: "family_1",
        font_top: "nc_font_1",
        font_bottom: "nc_font_2",
      },
      oldtimer: {
        text_top: "Ferrari 250 GT",
        text_bottom: "1956",
        default_example: "oldtimer_4",
        font_top: "nc_font_1",
        font_bottom: "sc_font_4",
      },
    },
    lineart: {
      animal: {
        text_single: "Oscar",
        default_example: "animal_3",
      },
    },
  };

function toggleStockAlertBasedOnTime() {
  var banner = document.querySelector(".lsa-banner");
  var currentHour = new Date().getHours();
  console.log(currentHour, "ch");
  // Check if the current time is between 12 PM (12:00) and 1 AM (01:00)
  if (banner && (currentHour >= 12 || currentHour < 1)) {
    banner.style.display = "block"; // Show the banner
  } else if (banner) {
    banner.style.display = "none"; // Hide the banner
  }
}

function setupHowToStepper() {
  // AERTQUARELL_HOW_TO_STEPPER
  var dist01 = 0,
    dist02 = 0,
    dist03 = 0,
    dist04 = 0;
  var half = window.innerHeight / 2.5;
  var windowElement = window;

  if (document.querySelector(".artquarell-how-to")) {
    dist01 = document.querySelector(".step.step01").offsetTop;
    dist02 = document.querySelector(".step.step02").offsetTop;
    dist03 = document.querySelector(".step.step03").offsetTop;
    dist04 = document.querySelector(".step.step04").offsetTop;
    scrolla(windowElement);
  }

  function scrolla(windowElement) {
    windowElement.addEventListener("scroll", function () {
      // Update the offset values dynamically
      if (document.querySelector(".artquarell-how-to")) {
        dist01 = document.querySelector(".step.step01").offsetTop;
        dist02 = document.querySelector(".step.step02").offsetTop;
        dist03 = document.querySelector(".step.step03").offsetTop;
        dist04 = document.querySelector(".step.step04").offsetTop;
      }

      var scrolltop = windowElement.scrollY;

      toggleClass(".step.step01", dist01 - half, scrolltop);
      toggleClass(".step.step02", dist02 - half, scrolltop);
      toggleClass(".step.step03", dist03 - half, scrolltop);
      toggleClass(".step.step04", dist04 - half, scrolltop);
    });
  }

  function toggleClass(selector, offset, scrolltop) {
    var element = document.querySelector(selector);
    if (scrolltop >= offset) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  }
}

// Function to replace {{variable_name}} in text nodes and attributes
function replaceTextNodes(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    const text = node.nodeValue;
    const replacedText = text.replace(
      /{{(.*?)}}/g,
      (match, p1) => translations[p1.trim()] || match
    );
    if (replacedText !== text) {
      // Replace the text node with a new HTML element if it contains HTML tags
      const span = document.createElement("span");
      span.innerHTML = replacedText;
      node.replaceWith(...span.childNodes);
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    // Replace placeholders in element attributes like placeholder
    if (node.hasAttributes()) {
      Array.from(node.attributes).forEach((attr) => {
        const attrValue = attr.value;
        const replacedAttrValue = attrValue.replace(
          /{{(.*?)}}/g,
          (match, p1) => translations[p1.trim()] || match
        );
        if (replacedAttrValue !== attrValue) {
          node.setAttribute(attr.name, replacedAttrValue);
        }
      });
    }
    // Continue replacing in child nodes
    node.childNodes.forEach((child) => replaceTextNodes(child));
  }
}

// Apply translations to cart items
function setUpTranslationsInCart() {
  const cartBody = document.querySelector(".m-cart__body");
  if (cartBody) {
    replaceTextNodes(cartBody); // Apply translations within the cart body
  }
}

function translateArtworks() {
  let attempts = 0;
  const maxAttempts = 10; // Limit to 10 attempts

  let checkTeeFormExist = setInterval(function () {
    const targetElement = document.querySelector("#teeFormInputs");
    if (targetElement) {
      clearInterval(checkTeeFormExist); // Stop checking once the element is found
      setUpTeeForm(targetElement, true);
      observeMutations(targetElement); // Start observing for dynamic change
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(checkTeeFormExist); // Stop checking after maximum attempts
      }
    }
  }, 500); // Check every 500 milliseconds

  function setUpTeeForm(element, differentProductSelected) {

    const art_type = window.productMetaArtType || "watercolor";

    const urlParams = new URLSearchParams(window.location.search);
    const queryTheme = urlParams.get('theme');
    const theme = themeSettings?.[art_type]?.[queryTheme || window.productMetaTheme];
    
    
    if (art_type && theme) {
      // Find elements for tb-text-field-top and tb-text-field-bottom
      const textTopElement = element.querySelector(
        ".tb-text-field-top .tee__input--text"
      );
      const textBottomElement = element.querySelector(
        ".tb-text-field-bottom .tee__input--text"
      );

      // Find the tb-examples container
      const examplesContainer = document.querySelector(".tb-examples");
      const chooseFontsContainers = document.querySelectorAll(
        ".tb-choose-font-top, .tb-choose-font-bottom"
      );
      const shippingContainer = element.querySelector(".tb-shipping-option");

      if (examplesContainer) {
        // Only on first load select default
        // Loop through all radio inputs within tb-examples and hide those not matching the theme
        const radioInputs = examplesContainer.querySelectorAll(
          'input[type="radio"]'
        );
        radioInputs.forEach((input) => {
          const imgElement = input
            .closest(".tee-clipart")
            .querySelector("label img");
          if (
            imgElement &&
            imgElement.alt.split("_")[0] !== queryTheme || window.productMetaTheme
          ) {
            // Hide the entire parent container if the alt does not match the theme
            input.closest(".tee-clipart-col").style.display = "none";
          }
        });
      }

      if (differentProductSelected) {
        if (chooseFontsContainers && theme.font_top) {
          const fontTopContainer = document.querySelector(
            ".tb-choose-font-top"
          );
          const defaultFontTop = fontTopContainer.querySelector(
            `input[type="radio"] ~ label img[alt="${theme.font_top}"]`
          );

          if (defaultFontTop) {
            const labelElement = defaultFontTop.closest("label");
            if (labelElement) {
              labelElement.click();
            } else {
              console.warn("Label element not found for the top font.");
            }
          }
        }

        if (chooseFontsContainers && theme.font_bottom) {
          const fontBottomContainer = document.querySelector(
            ".tb-choose-font-bottom"
          );
          const defaultFontBottom = fontBottomContainer.querySelector(
            `input[type="radio"] ~ label img[alt="${theme.font_bottom}"]`
          );

          if (defaultFontBottom) {
            const labelElement = defaultFontBottom.closest("label");
            if (labelElement) {
              labelElement.click();
            } else {
              console.warn("Label element not found for the bottom font.");
            }
          }
        }

        // Set default example by matching the alt attribute
        const defaultExampleElement = examplesContainer?.querySelector(
          `input[type="radio"] ~ label img[alt="${theme.default_example}"]`
        );
        if (defaultExampleElement) {
          const labelElement = defaultExampleElement.closest("label");
          if (labelElement) {
            labelElement.click();
          } else {
            console.warn("Label element not found for the default example.");
          }
        }

        if (shippingContainer && !artworkSetting.expressAvailable) {
          shippingContainer.style.display = "none";
        }
      }

      if (chooseFontsContainers) {
        chooseFontsContainers.forEach((fontContainer) => {
          const radioInputs = fontContainer.querySelectorAll(
            'input[type="radio"]'
          );
          radioInputs.forEach((input) => {
            const imgElement = input
              .closest(".tee-clipart")
              .querySelector("label img");
            if (
              !artworkSetting.fontCategories.includes(
                imgElement && imgElement.alt.split("_")[0]
              )
            ) {
              // Hide the entire parent container if the alt does not match the theme
              input.closest(".tee-clipart-col").style.display = "none";
            }
          });
        });
      }

      // Set value for tb-text-field-top
      if (textTopElement && !textTopElement.value) {
        textTopElement.value = theme.text_top || "";
        // Trigger input event to notify TeeInBlue of the change
        textTopElement.dispatchEvent(new Event("input"));
        textTopElement.dispatchEvent(new Event("change"));
      }

      // Set value for tb-text-field-bottom
      if (textBottomElement && !textBottomElement.value) {
        textBottomElement.value = theme.text_bottom || "";
        // Trigger input event to notify TeeInBlue of the change
        textBottomElement.dispatchEvent(new Event("input"));
        textBottomElement.dispatchEvent(new Event("change"));
      }
    } else {
      console.log("Product theme meta field not found.");
    }
    // Start the replacement process at the target element
    replaceTextNodes(element);
  }

  let activeProductIndex;

  function observeMutations(targetElement) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const selectedProductIndex = Array.from(
              document.querySelectorAll(".tee-radio")
            ).findIndex((radio) => radio.classList.contains("active")  && !radio.classList.contains("td-ignore"));
            const differentProductSelected =
              selectedProductIndex !== activeProductIndex;
            // Only apply translation logic, not the entire setup
            setUpTeeForm(node, differentProductSelected); // Only apply translations to newly added nodes
            activeProductIndex = selectedProductIndex;
          }
        });
      });
    });

    observer.observe(targetElement, {
      childList: true, // Observe direct children
      subtree: true, // Observe all descendants
    });
  }
}

function setupTeeGallery() {
  let attempts = 0;
  const maxAttempts = 10; // Limit to 10 attempts

  const teeGallary = document.querySelector(".tee-gallery-content");
  if (teeGallary) {
    teeGallary.style.removeProperty("height");
  }

  let checkExist = setInterval(function () {
    const targetElement = document.querySelector(".tee-slider");
    if (targetElement) {
      clearInterval(checkExist); // Stop checking once the element is found
      setupScrollListener(targetElement);
      markFavorites();
    } else {
      attempts++;
      if (attempts >= maxAttempts) {
        clearInterval(checkExist); // Stop checking after maximum attempts
      }
    }
  }, 500); // Check every 500 milliseconds

  function updateProductPreview() {
    // Find the new tee-slider content
    const newTeeSlider = document.querySelector(".tee-gallery .tee-slider");

    // Find the tee-slider inside tb-image-preview-mobile
    const mobileTeeSlider = document.querySelector(
      ".tb-image-preview-mobile .tee-slider"
    );

    if (newTeeSlider && mobileTeeSlider) {
      // Replace the content of the mobileTeeSlider with newTeeSlider content
      mobileTeeSlider.innerHTML = newTeeSlider.innerHTML;
    }
  }

  function setupProductChangeListener() {
    const productRadios = document.querySelectorAll(
      'input[name="availableProduct"]'
    );
    productRadios.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        console.log("Product changed:", event.target.value);
        updateProductPreview();
        setTimeout(updateProductPreview, 1000);
      });
    });
  }

  function setupScrollListener(element) {
    const targetOffsetTop = element.offsetTop;
    let wrappedElement = null; // Placeholder for the wrapped element
    const elStyle = window.getComputedStyle(element);
    const elementHeight = parseFloat(elStyle.height);

    window.addEventListener("scroll", function () {
      const teeGallery = document.querySelector(".tee-gallery .tee-slider");
      let elementPosition = teeGallery.getBoundingClientRect().bottom;
      //console.log('elementPosition ' + elementPosition)
      //console.log('elementHeight ' + elementHeight)
      if (elementPosition <= 100) {
        if (!wrappedElement) {
          // Create a wrapper div with the specified class
          isHide = true;
          wrappedElement = document.createElement("div");
          wrappedElement.className = isHide
            ? "tb-image-preview-mobile hide-preview"
            : "tb-image-preview-mobile";
          const headerHeight = element.style.height;
          const headerHeightOnHide = 100;
          wrappedElement.style.height = headerHeight;
          wrappedElement.style.marginTop =
            "-" + (parseInt(headerHeight) - headerHeightOnHide) + "px"; //

          const hideButton = document.createElement("div");
          hideButton.className = isHide
            ? "tb-image-preview-hide-btn hide-preview-btn"
            : "tb-image-preview-hide-btn";
          hideButton.addEventListener("click", () => {
            if (isHide) {
              isHide = false;
              hideButton.classList.remove("hide-preview-btn");
              wrappedElement.classList.remove("hide-preview");
              wrappedElement.style.marginTop = 0;
            } else {
              isHide = true;
              hideButton.classList.add("hide-preview-btn");
              wrappedElement.classList.add("hide-preview");
              wrappedElement.style.marginTop =
                "-" + (parseInt(headerHeight) - headerHeightOnHide) + "px";
            }
          });
          wrappedElement.appendChild(hideButton);

          // Clone the original element and remove all inline styles
          const clonedElement = teeGallery.cloneNode(true);
          clonedElement.style.cssText = ""; // Clear all inline styles

          // Append the cloned element to the wrapper
          wrappedElement.appendChild(clonedElement);
          setupProductChangeListener();

          // Find the container and insert the wrapper before it
          const container = document.querySelector("main");
          container.parentNode.insertBefore(wrappedElement, container);
        }
      } else {
        if (wrappedElement) {
          wrappedElement.remove(); // Remove the wrapper and its contents
          wrappedElement = null;
        }
      }
    });
  }

  function markFavorites() {
    // Select the parent div with class 'tb-choose-background'
    const backgroundDiv = document.querySelector(".tb-choose-background");

    // Check if the 'backgroundDiv' exists to avoid errors
    if (backgroundDiv) {
      // Find all divs with class 'tee-clipart' inside the parent div
      const clipartDivs = backgroundDiv.querySelectorAll(".tee-clipart-col");

      // Loop through each 'clipartDiv'
      clipartDivs.forEach((div) => {
        // Find the label with class 'tee-clipart-label' inside the current 'clipartDiv'
        const label = div.querySelector(".tee-clipart-label__text");

        // Check if the label exists and its text includes the word 'favorite'
        if (label && label.textContent.includes("favorite")) {
          console.log("CONTAINS");
          // Add the new class to the parent div of the label
          div.classList.add("tb-tee-clipart-label--favorite");
        }
      });
    }
  }
}

function insertFormatChange() {
  if (window.productMetaOrientationSibling) {
    const currentFormat = window.productMetaOrientation;
    const changeUrl = window.productMetaOrientationSibling;
    console.log("Format Changer Active!");
    console.log(currentFormat);

    function waitForElement(selector, action, checkInterval = 500, max = 10) {
      console.log("waitForElement");
      let round = 0;
      const intervalId = setInterval(function () {
        console.log("round", round);
        const element = document.querySelector(selector);
        if (element || round >= max) {
          clearInterval(intervalId);
          if (element) {
            action(element);
          }
        }
      }, checkInterval);
    }

    function insertHTMLAfterElement(element) {
      element.insertAdjacentHTML(
        "afterend",
        `
       <div class="tee-block tee-option tee-available-products" id="choose-print-format">
  <label class="tee-option__title">Wähle die Ausrichtung</label>
  <div class="tee-row">
    <div class="tee-radio active">
      <input
        name="fomatButton"
        id="ver"
        value="current"
      /><label
        title="Poster"
        class="tee-radio-label"
        >${currentFormat === "vertical" ? "Hochformat" : "Querformat"}</label
      >
    </div>
    <div class="tee-radio">
      <a
        name="fomatButton"
        href="${changeUrl}"
        id="hor"
        value="hor"
      /><label
        title="Leinwand"
        class="tee-radio-label"
        >${currentFormat === "vertical" ? "Querformat" : "Hochformat"} &#8599;</label
      >
    </div>
  </div>
</div>
      `
      );
    }

    waitForElement(".tee-product-price", insertHTMLAfterElement);
  }
}

/**
 * Cart Logic for Removing extras
 */

window.__BUNDLE_CASCADE_DEBUG__ = true;
const bcLog = (...a) => window.__BUNDLE_CASCADE_DEBUG__ && console.log('[BundleCascade]', ...a);

const isCartMutationUrl = (url) => {
  if (!url) return false;
  const u = String(url);
  return (
    u.includes('/cart/change') ||
    u.includes('/cart/update') ||
    u.includes('/cart/add') ||
    u.includes('/cart/clear')
  );
};

const fetchCart = async () => {
  const res = await fetch('/cart.js', { credentials: 'same-origin' });
  if (!res.ok) throw new Error('Could not load cart');
  return res.json();
};

// Parent ID on removed item
const getLiveId = (item) => {
  const id = item?.properties?._live_customization_id;
  return id == null ? '' : String(id);
};

// Child pointer on other items
const getBelongTo = (item) => {
  const v = item?.properties?._belongs_to;
  return v == null ? '' : String(v);
};

// Find which parent-IDs were removed in this mutation
const removedLiveIdsFromDiff = (prevCart, nextCart) => {
  const prev = prevCart?.items || [];
  const next = nextCart?.items || [];

  const prevByKey = new Map(prev.map(i => [i.key, i]));
  const nextByKey = new Map(next.map(i => [i.key, i]));

  const removedItems = [];

  // A) item disappeared
  for (const [key, prevItem] of prevByKey.entries()) {
    if (!nextByKey.has(key)) removedItems.push(prevItem);
  }

  // B) qty -> 0
  for (const [key, prevItem] of prevByKey.entries()) {
    const nextItem = nextByKey.get(key);
    if (!nextItem) continue;
    if ((prevItem.quantity || 0) > 0 && (nextItem.quantity || 0) === 0) removedItems.push(prevItem);
  }

  // Only take live ids from removed items
  const liveIds = [...new Set(removedItems.map(getLiveId).filter(Boolean))];

  bcLog('removed items:', removedItems.map(i => ({
    key: i.key,
    title: i.product_title,
    liveId: getLiveId(i),
    belongTo: getBelongTo(i),
    props: i.properties
  })));
  bcLog('removed liveIds:', liveIds);

  return liveIds;
};

const removeChildrenBelongingTo = async (liveId) => {
  if (!liveId) return false;

  const cart = await fetchCart();
  const children = cart.items.filter(i => getBelongTo(i) === String(liveId));

  bcLog('cascade liveId', liveId, 'children found:', children.map(i => ({
    key: i.key, title: i.product_title, qty: i.quantity, belongTo: getBelongTo(i)
  })));

  if (!children.length) return false;

  const updates = {};
  children.forEach(i => (updates[i.key] = 0));

  bcLog('posting /cart/update.js updates:', updates);

  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ updates }),
  });

  return true; // ✅ wir haben wirklich was entfernt
};

// --- Hook cart mutations (fetch) ---
(() => {
  if (window.__BUNDLE_CASCADE_INSTALLED__) return;
  window.__BUNDLE_CASCADE_INSTALLED__ = true;

  const originalFetch = window.fetch.bind(window);
  let internal = false;

  window.fetch = async (...args) => {
    const input = args[0];
    const url = typeof input === 'string' ? input : input?.url;

    if (internal || !isCartMutationUrl(url)) return originalFetch(...args);

    bcLog('intercept cart mutation:', url);

    const prev = await fetchCart().catch(() => null);
    const res = await originalFetch(...args);
    const next = await fetchCart().catch(() => null);

    if (prev && next) {
      const removedLiveIds = removedLiveIdsFromDiff(prev, next);

      if (removedLiveIds.length) {
        internal = true;
        let didRemoveAnyChild = false;

        try {
          for (const liveId of removedLiveIds) {
            const didRemove = await removeChildrenBelongingTo(liveId);
            if (didRemove) didRemoveAnyChild = true;
          }
        } finally {
          internal = false;
        }

        // ✅ nur EINMAL am Ende reloaden, und nur wenn wirklich was entfernt wurde
        if (didRemoveAnyChild) {
          bcLog('cascade removed children -> reloading once');
          window.location.reload();
        } else {
          bcLog('cascade found no children -> no reload');
        }
      } else {
        bcLog('no removed liveIds in this mutation');
      }
    }

    return res;
  };

  bcLog('installed (fetch)');
})();

// ═══ Saison-Banner (Ostern/Muttertag/MultiBuy) beim Impact-Port entfernt —
// ═══ Kampagnen laufen künftig über native Impact-Promo-Sections.

document.addEventListener("DOMContentLoaded", function () {
  translateArtworks();
  setupTeeGallery();
  toggleStockAlertBasedOnTime();
  setupHowToStepper();
  insertFormatChange();
  //initOsterSaleBanner();
  //initMuttertagsSaleBanner();
  // initMultiBuyBanner();
});

console.log(Shopify.customerPrivacy.userCanBeTracked() )
console.log(Shopify.customerPrivacy.getTrackingConsent() )